import { StarFilled, StarOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import styled from "styled-components";

interface FavoriteWellListButtonProps {
  isFavorite: boolean;
  onToggleFavorite: () => void;
  changeId: string;
}

export const FavoriteWellListButton = ({
  isFavorite,
  onToggleFavorite,
  changeId
}: FavoriteWellListButtonProps) => {
  const tooltipTitle = isFavorite
    ? "Remove as favourite well list"
    : "Mark as favourite well list";

  return (
    <Tooltip title={tooltipTitle}>
      <StyledButton
        data-testid={`favorite-well-list-button-${changeId}`}
        icon={isFavorite ? <StarFilled /> : <StarOutlined />}
        onClick={(e) => {
          e.stopPropagation();
          onToggleFavorite();
        }}
        className={isFavorite ? "favorite-active" : ""}
      />
    </Tooltip>
  );
};

const StyledButton = styled(Button)`
  color: #a2aaad;
  border: 1px solid #d9d9d9;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1); // use ant-design transition
  }

  &:hover {
    color: var(--color-primary);
    border-color: var(--color-primary);
  }

  &.favorite-active {
    border-color: var(--color-primary);
    background: var(--color-primary);

    svg {
      color: white;
    }
  }

  &.favorite-active:hover {
    background: white;

    svg {
      color: var(--color-primary);
    }
  }
`;
